export default {
  toasts: {
    failed_to_create_website: 'Échec de la création du site web',
  },
  steps: {
    information: 'Informations',
    template: 'Modèle',
  },
  buttons: {
    next: 'Suivant',
    previous: 'Précédent',
    create_website: 'Créer le site web',
    preview_about_us: 'À propos (Aperçu)',
  },
  about_us_modal: {
    title: 'À propos (Aperçu)',
  },
  error_messages: {
    missing_fields:
      'Certains champs obligatoires sont manquants. Veuillez remplir toutes les informations nécessaires avant de continuer.',
  },
};
